import React from "react";
import DataTable from "react-data-table-component";

const Table = ({
  title,
  columns,
  data,
  pagination = false,
  defaultSortField,
  defaultSortAsc = true,
  onSelectedRowsChange,
  conditionalRowStyles,
  subHeader,
  subHeaderComponent,
  paginationPerPage,
  onChangeRowsPerPage,
  onChangePage,
  paginationRowsPerPageOptions,
  currentPage,
  totalRowCount,
  paginationServer = true,
  onSort,
  serverSideSort = false,
  NoRecordsText,
  sortColumn,
  sortDirection,
  fixedHeader = false,
  fixedHeaderScrollHeight = "300px",
  showPaginationInfo = true,
}) => {
  const totalPages = Math.ceil(totalRowCount / paginationPerPage);
  const [inputPage, setInputPage] = React.useState(currentPage);

  // Sync local input page state if `currentPage` changes externally
  React.useEffect(() => {
    setInputPage(currentPage);
  }, [currentPage]);
  return (
    <>
      <DataTable
        title={title}
        columns={columns}
        data={data}
        pagination={false}
        paginationPerPage={paginationPerPage}
        paginationRowsPerPageOptions={
          paginationRowsPerPageOptions || [10, 25, 50, 100, 200]
        }
        onChangeRowsPerPage={onChangeRowsPerPage}
        onChangePage={onChangePage}
        paginationTotalRows={totalRowCount}
        paginationDefaultPage={currentPage}
        paginationServer={paginationServer}
        onSort={onSort}
        sortServer={serverSideSort}
        sortColumn={sortColumn}
        sortDirection={sortDirection}
        defaultSortField={sortColumn}
        defaultSortAsc={sortDirection === "asc"}
        noDataComponent={
          <b className="table-no-data-text mt-5 fs-4 mb-5">
            {NoRecordsText || "No data found"}
          </b>
        }
        className={
          data?.length === 0 || data?.length === undefined
            ? "no-data-table border-radius-none font-size-14"
            : "data-table border-radius-none font-size-14"
        }
        fixedHeader={fixedHeader}
        fixedHeaderScrollHeight={fixedHeaderScrollHeight}
      />
      {pagination && data?.length > 0 && (
        <div className="row">
          <div className="pagination-postion d-flex justify-content-between align-items-center py-2 col-lg-12 col-md-12 col-md-sm-4 flex-wrap gap-2">
            <div className="fs-5 mb-0 mt-0 totalRecordss">
              Total No.of Records: {totalRowCount}
            </div>

            {showPaginationInfo && (
              <div className="fs-12 mt-0 text-center ">
                {/* First page */}
                <button
                  className="table_first_page_btn"
                  onClick={() => onChangePage?.(1)}
                  disabled={currentPage === 1}
                  aria-label="First Page"
                  style={{
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  }}
                >
                  {"<<"}
                </button>

                {/* Previous page */}
                <button
                  onClick={() =>
                    currentPage > 1 && onChangePage?.(currentPage - 1)
                  }
                  disabled={currentPage === 1}
                  className="table_prev_page_btn"
                  aria-label="Previous Page"
                  style={{
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  }}
                >
                  {"<"}
                </button>

                <span>Page </span>
                <input
                  type="number"
                  min={1}
                  max={totalPages}
                  value={inputPage}
                  onChange={(e) => {
                    setInputPage(e.target.value); // update local input state only
                  }}
                  onBlur={() => {
                    const newPage = Number(inputPage);
                    if (
                      newPage >= 1 &&
                      newPage <= totalPages &&
                      newPage !== currentPage
                    ) {
                      onChangePage?.(newPage);
                    } else {
                      setInputPage(currentPage); // reset to actual page if invalid
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      const newPage = Number(inputPage);
                      if (
                        newPage >= 1 &&
                        newPage <= totalPages &&
                        newPage !== currentPage
                      ) {
                        onChangePage?.(newPage);
                      }
                    }
                  }}
                  className="small-input"
                  style={{
                    width: 50,
                    textAlign: "center",
                    borderRadius: 4,
                    border: "1px solid #ccc",
                    padding: "2px 4px",
                  }}
                />
                <span> of {totalPages}</span>
                {/* Next page */}
                <button
                  className="table_next_page_btn"
                  onClick={() =>
                    currentPage < totalPages && onChangePage?.(currentPage + 1)
                  }
                  disabled={currentPage === totalPages}
                  aria-label="Next Page"
                  style={{
                    cursor:
                      currentPage === totalPages ? "not-allowed" : "pointer",
                  }}
                >
                  {">"}
                </button>
                {/* Last page */}
                <button
                  className="table_last_page_btn"
                  onClick={() => onChangePage?.(totalPages)}
                  disabled={currentPage === totalPages}
                  aria-label="Last Page"
                  style={{
                    cursor:
                      currentPage === totalPages ? "not-allowed" : "pointer",
                  }}
                >
                  {">>"}
                </button>
              </div>
            )}

            {/* ✅ Rows per page dropdown */}

            <div className="fs-5 mb-0">
              Rows per page:{" "}
              <select
                value={paginationPerPage}
                onChange={(e) => {
                  const newPerPage = Number(e.target.value);
                  onChangeRowsPerPage?.(newPerPage, 1); // Reset to first page
                }}
                style={{
                  marginLeft: 8,
                  padding: "4px 8px",
                  borderRadius: 4,
                  border: "1px solid #ccc",
                }}
              >
                {[10, 25, 50, 100, 200].map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Table;
